/* Dev-only logger: silenced in production builds. */
const IS_DEV = process.env.NODE_ENV === 'development';

export const logDebug = (...args) => {
  if (IS_DEV) console.debug(...args);
};

export const logWarn = (...args) => {
  if (IS_DEV) console.warn(...args);
};

export const logError = (...args) => {
  // Errors are always logged so production support can grep server-pushed logs.
  console.error(...args);
};
